import { useEffect, useRef, useState } from "react";
import { useQuery } from "react-apollo";

import nanoid from "nanoid";

import { useStore } from "../providers/AppProvider";

import { GET_L2_DATA_SOURCES } from "../../../queries";

import { GetDataSource_syncarto_app_data_source } from "../../../__generated__/types";
import { DataSourceLayerMeta, DataSourceRasterLayer, DataSourceRasterLayerExtended } from "../types/types";
import { getTileUrlTemplate } from "../utils/dataSourceUtils";

import ESRI_SATELLITE from '../components/Map/styles/esri-satellite.json';
import { MAPBOX_SATELLITE } from '../components/Map/styles/mapbox-satellite';
import ESRI_BASE_LABELS from '../components/Map/styles/esri-labels.json';

export const useL2RasterDataSources = (exclusions: any) => {
    const {settings} = useStore();

    const [dataSources, setDataSources] = useState<DataSourceRasterLayer[]>([]);
    const {data, loading} = useQuery(GET_L2_DATA_SOURCES, { 
        fetchPolicy: "no-cache",
        variables: {level: 2 }, 
    });

    const tsRef = useRef<string | null>(null);

    useEffect(() => {
        if(!loading && data) { 
            let settingsTs = null;
            if('indices_date' in settings) {
                const obj = JSON.parse(settings['indices_date']);
                settingsTs = obj.end_date;
            }

            if(tsRef.current !== settingsTs) {
                tsRef.current = settingsTs;
            } else {
                if(dataSources.length) {
                    return;
                }
            }

            const sources = data.syncarto_app_data_source.sort((a:any, b:any) => (a.title.replace("High Res. ", "") && b.title.replace("High Res. ", "")) ? a.title.replace("High Res. ", "").toLowerCase().localeCompare(b.title.replace("High Res. ", "")) : -1).reverse();
            console.log("sources", sources)
            console.log("exclusions", exclusions)
            const sourcesIncluded = sources.filter((ds: DataSourceRasterLayerExtended) => {
                return !exclusions.includes(ds.collection_id);
            });
            const layers: DataSourceRasterLayer[] = sourcesIncluded.map((source: DataSourceRasterLayerExtended, index:number) => {
                let _uuid = nanoid(8); 
                const dataSourceLayer: DataSourceRasterLayer = {
                    name: source.title,
                    id: source.collection_id!,
                    uuid: _uuid,
                    min_zoom: source.max_zoom_level ? source.max_zoom_level : 0,
                    max_zoom: source.min_zoom_level ? (source.min_zoom_level >= 25 ? 24 : 24) : 24,
                    is_visible: false, //dataSourceMeta?.visible!,
                    type: 'overlay', //dataSourceMeta?.type!,
                    order: index, //dataSourceMeta?.order!,
                    display: source.title.replace("High Res. ", ""), //dataSourceMeta?.display,
                    tiles: source.stac_address 
                        ? getTileUrlTemplate(
                            source,
                            source.stac_address!, 
                            source.collection_id!,
                            'footprint_id',
                            source.min_date,
                            tsRef.current ? tsRef.current : source.max_date,
                            source.date_display_resolution!,
                            "template-singledate-p1",
                            null,
                        ) 
                        : source.tile_urls,
                    source: {...source}
                };
                return dataSourceLayer;
                
            });
            setDataSources(layers);
        }
    }, [loading, settings]);

    return { dataSources, loading };
}